module.exports = __webpack_public_path__ + "/fcef6ac3874368d084b8bb6b576f7188.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/security_icon.svg
 ** module id = 1645
 ** module chunks = 0
 **/